import { render, staticRenderFns } from "./lieferanteninfo.vue?vue&type=template&id=57985dc8&scoped=true"
import script from "./lieferanteninfo.vue?vue&type=script&lang=js"
export * from "./lieferanteninfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57985dc8",
  null
  
)

export default component.exports